import Vue from 'vue';
import Router from 'vue-router';
import QueryIndex from '@/components/QueryIndex';
import OrderDetail from '@/components/OrderDetail';

Vue.use(Router);

export default new Router({
  routes: [
    {
      path: '/',
      name: 'QueryIndex',
      component: QueryIndex,
      meta: {
        keepAlive: true
      }
    },
    {
      path: '/OrderDetail/:orderNo',
      name: 'OrderDetail',
      component: OrderDetail
    },
  ],
});



// WEBPACK FOOTER //
// ./src/router/index.js